import createTheme from "@mui/material/styles/createTheme";
import {deepPurple, green, lightGreen} from "@mui/material/colors";

export const theme =
  createTheme({
    root: {
      position: 'absolute',
      height: '100%'
    },
    components: {
      MuiModal: {
        styleOverrides: {
          root: {
            outline: "none",
            boxShadow: "none",
          },
        },
      },
      MuiButton: {
        defaultProps: {
          size: "small",
          disableElevation: true,
        },
        styleOverrides: {
          root: {
            borderRadius: 8,
            textTransform: "none",
            fontWeight: 500,
            boxShadow: "none",
            fontSize: "0.78rem",
            lineHeight: 1.5,
            padding: "6px 12px",
            minWidth: "auto",
          },
        },
        variants: [
          {
            props: {variant: "primary"},
            style: ({theme}) => ({
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              border: "none",
              transition: "background-color .2s ease, box-shadow .2s ease",
              "&:hover": {backgroundColor: "#6b79e8", boxShadow: "0 4px 6px rgba(132, 145, 247, 0.45)"},
              "&.Mui-disabled": {backgroundColor: theme.palette.primary.main, opacity: 0.5, color: theme.palette.primary.contrastText},
            }),
          },
          {
            props: {variant: "modal"},
            style: ({theme}) => ({
              backgroundColor: theme.palette.secondary.main,
              color: theme.palette.secondary.contrastText,
              border: "none",
              transition: "background-color .2s ease, box-shadow .2s ease",
              "&:hover": {backgroundColor: "#454341", boxShadow: "0 4px 12px rgba(44, 43, 42, 0.3)"},
              "&.Mui-disabled": {backgroundColor: theme.palette.secondary.main, opacity: 0.5, color: theme.palette.secondary.contrastText},
            }),
          },
          {
            props: {variant: "ghost",size: "small"},
            style: ({theme}) => ({
              backgroundColor: "transparent",
              color: theme.palette.text.primary,
              border: "none",
              boxShadow: "none",
              "&:hover": {backgroundColor: "rgba(132, 145, 247, 0.08)"},
            }),
          },
        ],
      },
    },
    palette: {
      primary: {
        // light: will be calculated from palette.primary.main,
        main: '#8491F7',
        contrastText: '#ffffff',
        white: '#ffffff'
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      teal: {
        main: "#D7E8F4",
        contrastText: "#2C2B2A"
      },
      secondary: {
        main: "#2C2B2A",
        contrastText: '#ffffff',
        white: '#ffffff'
      },
      white: "#FFFFFF",
      background1: "#FEFEFE",
      background2: "#EAEAEA",
      // info: {
      //   main: "#1DAEFF",
      //   contrastText: "#FFF"
      // },
      light: {
        main: "#EAEAEA",
        contrastText: "#2C2B2A"
      },
      dark: {
        main: "#2C2B2A",
        contrastText: "#EAEAEA"
      },
      neutral: {
        main: '#ffffff',
        gray: '#f4f6f6',
        gray2: '#adadad',
      },
      azure: {
        default: '#1DAEFF',
        main: '#1DAEFF',
        dark: '#1196e1',
        light: '#1DAEFFee',
        contrastText: "#EAEAEA",
      },
      confirmation: {
        main: '#09D92A',
        contrastText: '#ffffff',
        dark: "#2FA642"
      },
      purple: {
        main: deepPurple[500],
        light: deepPurple[200],
      },
      success: {
        default: lightGreen[600],
        main: lightGreen[600],
        dark: green[800],
        light: green[400],
        contrastText: '#ffffff',
      },
      error: {
        main: '#dc2626',
        dark: '#b91c1c',
        light: '#fef2f2',
        contrastText: '#ffffff',
      },
      warning: {
        main: '#f5b301',
        dark: '#a16207',
        light: '#fef9c3',
        contrastText: '#2C2B2A',
      },
      text: {
        primary: '#252525',
        secondary: '#4e5860',
      },
    },
    typography: {
      fontFamily: "Inter, sans-serif",
      h1: {
        fontSize: '2.8rem'
      },
      h2: {
        fontSize: '2.2rem'
      },
      h3: {
        fontSize: '1.7rem'
      },
      h4: {
        fontSize: '1.2rem'
      },
      h5: {
        fontSize: '1rem'
      },
      h6: {
        fontSize: '0.9rem'
      },
      body1: {
        fontSize: '0.9rem',
        fontWeight: 300
      },
      body2: {
        fontSize: '0.8rem',
        fontWeight: 300
      },
      subtitle1: {
        fontSize: '0.9rem',
        fontWeight: 300
      },
      subtitle2: {
        fontSize: '0.8rem',
        fontWeight: 300
      },
      caption: {
        fontSize: '0.75rem',
        fontWeight: 300
      },
      button: {
        textTransform: "none"
      }

    },
    action: {
      hover: '#1B8EB1',
      active: '#1B8EB1',
    }
  })
